export default __webpack_public_path__ + "static/media/TUSD.f65c22bb.png";